// Wire contract for disc/drive content intake (ADR-021). The browser uploads
// straight to the media content store; the portal API only coordinates.
export const MEDIA_CONTENT_BLOCK_SIZE = 32 * 1024 * 1024;
export const MAX_MEDIA_CONTENT_BYTES = 256 * 1024 * 1024 * 1024;
export const MAX_MEDIA_CONTENT_FILES = 20_000;
export const MEDIA_CONTENT_MAX_INFLIGHT = 6;
export const MEDIA_CONTENT_SAS_REFRESH_LEAD_MS = 10 * 60 * 1000;
//# sourceMappingURL=media-content.js.map